import { Tag } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const TagsList = ({ tags, groupTags, numberOfTagsToDisplay, onGroupedTagsClick, sizeTag, classTooltip }) => {
  return (
    <div className="tags-list">
      {tags.slice(0, groupTags ? numberOfTagsToDisplay : tags.length).map((tag, index) => {
        const { text, ...rest } = tag;
        return <Tag key={tag.guid || tag.id || index} {...rest} label={text} size={sizeTag} tooltipClassName={classTooltip} />;
      })}
      {Boolean(groupTags && tags.length > 6) && (
        <Tag label={`+${tags.length - 6}`} onClick={onGroupedTagsClick} size={sizeTag} tooltipClassName={classTooltip} />
      )}
    </div>
  );
};

TagsList.propTypes = {
  tags: PropTypes.array,
  groupTags: PropTypes.bool,
  numberOfTagsToDisplay: PropTypes.number,
  onGroupedTagsClick: PropTypes.func,
  sizeTag: PropTypes.string,
  classTooltip: PropTypes.string,
};

TagsList.defaultProps = {
  tags: [],
  groupTags: false,
  numberOfTagsToDisplay: 6,
  onGroupedTagsClick: () => {},
};

export default TagsList;
